import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from "vue";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {Api, gridActionFailure} from "@/shared/services/api";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import Insurance from "@/shared/model/Insurance";
import {useNavigationStore} from "@/modules/Navigation/store";

interface Props {
  id?: string
  selected?: (array: Insurance[]) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceListComponent',
  props: {
    id: { default: undefined },
    selected: { type: Function, default: undefined }
  },
  emits: ["selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const _emit = __emit


/*
const  _filterSettings = { type: 'Excel' }  //Menu CheckBox FilterBar Excel
*/


const _url = Api.baseUrl + '/InsuranceList';
const _navigationStore = useNavigationStore()

const _adaptor = new CustomAdaptor()

const _dataManager = ref<DataManager | undefined>()

const _dataManager1 = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})

const _grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}
const selectionOptions = {type: 'Multiple', checkboxOnly: false, enableToggle: true}

function onRowSelected(args: any) {
  _navigationStore.currentInsuranceId = args?.data?.id
  _navigationStore.currentInsuranceNumber = args?.data?.insuranceNumber
  _emit("selected", args.data)
  onSelected()
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _navigationStore.currentInsuranceId = undefined
  _navigationStore.currentInsuranceNumber = undefined
  _emit("selected", undefined)
  onSelected()
}

function onSelected() {
  if (props.selected) {
    const list = _grid.value?.getSelectedRecords()?.map(t => t as Insurance);
    props.selected(list ?? [])
  }
}

function refresh() {
  if (!_dataManager.value) {
    _dataManager.value = _dataManager1
  }

  _grid.value?.refresh()
}

function calcEvb(field: string, data: any) {
  const form = data['formNumber'] ?? ""
  const evb = data[field] ?? ""
  return (evb && evb !== "null") ? evb : "" + (form && form !== "null") ? form : ""
}

__expose({
  adaptor: _adaptor, refresh
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(GridComponent), {
      id: "personList",
      ref_key: "_grid",
      ref: _grid,
      "data-source": _dataManager.value,
      "allow-paging": true,
      "allow-sorting": true,
      width: "auto",
      "allow-reordering": true,
      "allow-resizing": true,
      "show-column-menu": false,
      "allow-text-wrap": true,
      "row-selected": onRowSelected,
      "row-deselected": onRowDeselected,
      "page-settings": _pageSettings,
      "action-failure": _unref(gridActionFailure),
      "selection-settings": selectionOptions
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ColumnsDirective), null, {
          default: _withCtx(() => [
            _createVNode(_unref(ColumnDirective), {
              type: "checkbox",
              width: "45"
            }),
            _createVNode(_unref(ColumnDirective), {
              "header-text": "",
              template: 'cTemplate',
              width: "28",
              "allow-sorting": false
            }, {
              cTemplate: _withCtx(({data}) => [
                _withDirectives(_createVNode(SogIcon, { icon: "mdi-car" }, null, 512), [
                  [_vShow, data.vehicleRegistrationId]
                ]),
                _withDirectives(_createVNode(SogIcon, {
                  icon: "mdi-close",
                  class: "cl"
                }, null, 512), [
                  [_vShow, data.hasCancellationSupplier||data.hasCancellationPerson]
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "insuranceNumber",
              "header-text": "VSNR",
              "auto-fit": true
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "grossPrice",
              "header-text": "Prämie, €",
              "auto-fit": true,
              format: "n2",
              type: "number"
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "createDate",
              "header-text": "Bestelldatum",
              "auto-fit": true,
              format: "dd.MM.yyyy HH:mm:ss",
              type: "dateTime"
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "evb",
              "header-text": "eVB/Form.Nr.",
              "auto-fit": true,
              "value-accessor": calcEvb
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "activationDate",
              "header-text": "Aktivierungsdatum",
              "auto-fit": true,
              format: "dd.MM.yyyy HH:mm:ss",
              type: "dateTime"
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "evbValidityDate",
              "header-text": "Gültig bis",
              "auto-fit": true,
              format: "dd.MM.yyyy",
              type: "dateTime"
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "productDescription",
              "header-text": "",
              "auto-fit": true,
              "allow-sorting": false
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "manufacturerName",
              "header-text": "Versicherer",
              "auto-fit": true,
              "allow-sorting": false
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "action-failure"])
  ]))
}
}

})